import { Row, Col, Card } from 'antd';
import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import PageHeading from '../../../../../components/common/PageHeading';
import RightBar from '../../../../../components/common/RightBar';
import { SurveysRightBar } from '../../surveysData';
import './SurveyDetails.css'
import { TiArrowBack } from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from '@ant-design/icons';



const SurveysDetails = () => {

    const location = useLocation();
    const rowData = location.state.rowData;

    const [surveyDetails, setSurveyDetails] = useState(rowData);
    console.log("data surveyDetails=>>>", surveyDetails)

    const navigate = useNavigate();


    return (
        <>
            <div>

                <div
                    className="back-container"
                    onClick={() => navigate("/reporting/surveys")}
                >
                    <TiArrowBack size={20} />
                    <span>Back to All Responses</span>
                </div>
                
                
                <PageHeading heading="Maintenance Survey Response" />
                <Row gutter={[2, 2]}>
                    <Col className='survery-details-col' span={24}>
                        <p className='survery-details'>Submitted by: </p><Link to="/page1">{surveyDetails.submittedBy}</Link>
                    </Col>
                    <Col className='survery-details-col' span={24}>
                        <p className='survery-details'>Evaluated Job: </p><Link to="/page1">{surveyDetails.personEvaluated}</Link>
                    </Col>
                    <Col className='survery-details-col' span={24}>
                        <p className='survery-details'>Evaluated Person: </p><Link to="/page1">{surveyDetails.personEvaluated}</Link>
                    </Col>
                    <Col className='survery-details-col' span={24}>
                        <p className='survery-details'>Property: </p><Link to="/page1">{surveyDetails.property}</Link>
                    </Col>
                </Row>
                <Row>

                    <Card title="Responses" style={{ width: '100%', margin: '20px 0px' }}>
                        <Row gutter={[16, 16]}>

                            <Col span={24}>
                                <label> 1. How satisfied are you with the overall experience?</label>
                                <p className='response' >88</p>
                            </Col>

                            <Col span={24}>
                                <label> 2. Has the issue been resolved completely?</label>
                                <p className='response' >Yes</p>
                            </Col>
                            <Col span={24}>
                                <label> 3. Was the work completed in a timely manner?
                                </label>
                                <p className='response' >Yes</p>
                            </Col>

                            <Col span={24}>
                                <label>  4. Any additional feedback?</label>
                                <p className='response' >He Got it done great</p>
                            </Col>
                        </Row>

                    </Card>
                </Row>
            </div>
            <div className="RightSidebar">
                <RightBar RightBarData={SurveysRightBar} />
            </div>
        </>
    )
}

export default SurveysDetails;